import styled from 'styled-components'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import colors from '../../../../configuration/colors'
import LevelTargetDate from '../../../../static/images/icons/icon-Level_Target_Date.svg'
import { H6, P1 } from '../../../styled/typography/typography'

const Container = styled.div`
  width: 568px;
  border-radius: 20px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  overflow: auto;
  background: ${props => props.theme.modalBackground};
  margin-bottom: 30px;
`

const ModalTop = styled.div`
  height: 115px;
  padding: 64px 10px 10px 32px;
  position: relative;
  background-color: ${props => `#${props.color}`};

  .target-date {
    font-weight: 500;
    color: ${colors.dove};
    background: 0 50% url(${LevelTargetDate}) no-repeat;
    background-size: 16px;
  }
`

const ModalBody = styled(FlexAlignCenter)`
  padding: 24px 0 31px;
  background: ${props => props.theme.modalBackground};
  justify-content: center;
  flex-direction: column;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  max-height: 90%;
  text-align: left;
`

const QuestsContainer = styled.div`
  width: 541px;
  border: ${props => props.theme.scheduleBorder};
  border-radius: 20px;
  background-color: ${props => props.theme.selectBackground};
  padding: 23px 18px 15px 18px;
  margin-bottom: 14px;

  .__react_component_tooltip {
    padding: 0 !important;
    background: ${props => props.theme.footerBackground} !important;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
    border-radius: 10px !important;
    border: none;

    &.place-left {
      &:before {
        border-left: 8px solid ${colors.smoke};
      }

      &:after {
        border-left-color: ${colors.white} !important;
      }
    }

    &.place-top {
      &:before {
        border-top: 8px solid ${colors.smoke};
      }

      &:after {
        border-top-color: ${colors.white};
      }
    }

    &.place-bottom {
      &:before {
        border-bottom: 8px solid ${colors.smoke};
      }

      &:after {
        border-bottom-color: ${colors.white};
      }
    }

    &.place-right {
      &:before {
        border-right: 8px solid ${colors.smoke};
      }

      &:after {
        border-right-color: ${colors.white};
      }
    }
  }
`

const H6QuestName = styled(H6)`
  margin-left: 10px;
  text-align: left;
`

const P1Description = styled(P1)`
  color: ${colors.dove};
  width: 500px;
`

export {
  Container,
  ModalTop,
  ModalBody,
  QuestsContainer,
  H6QuestName,
  P1Description
}
